import { render, staticRenderFns } from "./ActividadPerifericos.vue?vue&type=template&id=31fbfc58&"
import script from "./ActividadPerifericos.vue?vue&type=script&lang=js&"
export * from "./ActividadPerifericos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports